var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgEHeatingTightValveSymbol = function SvgEHeatingTightValveSymbol(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 684 480"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 684,
    height: 480,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 485,
    cy: 250,
    r: 11,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485,240c5.51,0,10,4.49,10,10s-4.49,10-10,10-10-4.49-10-10,4.49-10,10-10M485,239c-6.08,0-11,4.92-11,11s4.92,11,11,11,11-4.92,11-11-4.92-11-11-11h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M485,257.7c-3.24,0-5.88-2.64-5.88-5.88,0-2.5,3.74-7.39,5.55-9.37l.37-.4.37.4c1.71,1.85,5.47,6.77,5.47,9.37,0,3.24-2.63,5.88-5.87,5.88ZM485.04,243.54c-2.17,2.48-4.92,6.48-4.92,8.28,0,2.69,2.19,4.88,4.88,4.88s4.87-2.19,4.87-4.88c0-1.8-2.7-5.87-4.83-8.28Z",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 492.76,
    y1: 257.74,
    x2: 477.31,
    y2: 242.29,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 484.54,
    y: 239.09,
    width: 1,
    height: 21.86,
    transform: "translate(-34.72 416.22) rotate(-45)"
  }))))));
};
export default SvgEHeatingTightValveSymbol;